import { useEffect, useState } from "react";
import { api } from "./api";

const SATUAN = ["", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan", "sepuluh", "sebelas"];
function belowThousand(n: number): string {
  if (n < 12) return SATUAN[n];
  if (n < 20) return `${SATUAN[n - 10]} belas`;
  if (n < 100) return `${SATUAN[Math.floor(n / 10)]} puluh${n % 10 ? ` ${SATUAN[n % 10]}` : ""}`;
  const h = Math.floor(n / 100);
  return `${h === 1 ? "seratus" : `${SATUAN[h]} ratus`}${n % 100 ? ` ${belowThousand(n % 100)}` : ""}`;
}
export function terbilang(n: number): string {
  n = Math.floor(Math.abs(Number(n) || 0));
  if (n === 0) return "nol rupiah";
  const units = ["", "ribu", "juta", "miliar", "triliun"];
  const parts: string[] = [];
  let i = 0;
  while (n > 0 && i < units.length) {
    const chunk = n % 1000;
    n = Math.floor(n / 1000);
    if (chunk) parts.unshift(chunk === 1 && i === 1 ? "seribu" : `${belowThousand(chunk)} ${units[i]}`.trim());
    i++;
  }
  return `${parts.join(" ")} rupiah`;
}


export const receiptFileName = (receiptNo: string, student?: { internal_id?: string; name?: string } | null) => {
  const parts = [receiptNo.replace(/\//g, "-")];
  if (student?.internal_id) parts.push(student.internal_id);
  if (student?.name) parts.push(student.name.trim().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").toUpperCase().slice(0, 40));
  return `${parts.join("_")}.pdf`;
};
export const fmtIDR = (n: number | null | undefined) => "Rp " + new Intl.NumberFormat("id-ID").format(Math.round(n || 0));

export const fmtNum = (n: number | null | undefined) => new Intl.NumberFormat("id-ID").format(Math.round(n || 0));

export function addMonthsStr(s: string, n: number): string {
  if (!s) return "";
  const d = new Date(`${s}T00:00:00`);
  const day = d.getDate();
  d.setDate(1);
  d.setMonth(d.getMonth() + n);
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  d.setDate(Math.min(day, last));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function fmtDate(s?: string | null) {
  if (!s) return "-";
  const d = new Date(s.length === 10 ? s + "T00:00:00" : s);
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(s?: string | null) {
  if (!s) return "-";
  return new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const STATUS: Record<string, { label: string; cls: string; dot: string }> = {
  open: { label: "Open", cls: "bg-red-100 text-red-700 border-red-300 dark:bg-red-950/60 dark:text-red-300 dark:border-red-800", dot: "bg-red-500" },
  partial: { label: "Partial Paid", cls: "bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800", dot: "bg-amber-500" },
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800", dot: "bg-emerald-500" },
  lunas: { label: "Lunas", cls: "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-950/60 dark:text-blue-300 dark:border-blue-800", dot: "bg-blue-500" },
};

export const COL_COLORS: Record<number, string> = { 1: "#16A34A", 2: "#F59E0B", 3: "#F97316", 4: "#EF4444", 5: "#991B1B" };
export const COL_LABELS: Record<number, string> = { 1: "Lancar", 2: "Perhatian Khusus", 3: "Kurang Lancar", 4: "Diragukan", 5: "Macet" };

export const ROLE_LABELS: Record<string, string> = {
  super_admin: "Super Admin",
  admin_ops: "Admin Operasional",
  inputer: "Inputer",
  kepala_koperasi: "Kepala Koperasi",
  viewer: "Viewer/Pimpinan",
};

export const GUARANTORS = ["Magang - LPK Yutaka Education Center", "PMI - Yutaka Saiyou Galuh Persada", "Magang - LPK MJI Education Service"];

let gCache: string[] | null = null;
export function useGuarantors(extra?: string): string[] {
  const [list, setList] = useState<string[]>(gCache || GUARANTORS);
  useEffect(() => {
    if (gCache) return;
    api.get("/config").then((r) => { gCache = r.data.guarantors?.length ? r.data.guarantors : GUARANTORS; setList(gCache!); }).catch(() => {});
  }, []);
  return extra && !list.includes(extra) ? [...list, extra] : list;
}
export const resetGuarantorsCache = () => { gCache = null; };

export const RTYPE_LABELS: Record<string, string> = {
  adjust_outstanding: "Koreksi Outstanding",
  early_settlement: "Pelunasan Maju",
  adjust_installment: "Penyesuaian Cicilan",
  dispensation: "Dispensasi Cicilan",
  accelerate: "Percepatan Jadwal",
};

export const APPROVAL_TYPE: Record<string, string> = { restructure: "Restrukturisasi", void_payment: "Void Transaksi" };
